<template>
  <v-container class="mb-12">
    <v-flex>
      <v-layout justify-center>
        <Logo></Logo>
      </v-layout>

      <h1 class="text-center mb-4">Links</h1>

      <v-card
          class="mx-auto mb-7"
          max-width="450"
      >
        <v-layout>
          <v-layout justify-end col xs6>
            <v-icon x-large>mdi-link</v-icon>
          </v-layout>
          <v-layout column justify-space-around col xs6>
            <a href="" @click.stop.prevent="dialog = true">Other sgRNA tools</a>
          </v-layout>
        </v-layout>

        <v-layout>
          <v-flex col xs6>
            <img src="../assets/img/github.svg" height="70" class="ml-auto"/>
          </v-flex>
          <v-layout column justify-space-around col xs6>
            <a href="https://github.com/GMichlits/VBC-Score" target="_blank">Code at GitHub</a>
          </v-layout>
        </v-layout>

        <v-layout>
          <v-flex col xs6>
            <img src="../assets/img/publication.png" height="70" class="ml-auto"/>
          </v-flex>
          <v-layout column justify-space-around col xs6>
            <a href="https://www.nature.com/articles/s41592-020-0850-8" target="_blank">Publication</a>
          </v-layout>
        </v-layout>

        <v-layout>
          <v-flex col xs6>
            <img src="../assets/img/imba.svg" height="70" class="ml-auto"/>
          </v-flex>
          <v-layout column justify-space-around col xs6>
            <a href="https://www.imba.oeaw.ac.at/research/ulrich-elling/" target="_blank">Elling lab</a>
            <a href="https://www.imba.oeaw.ac.at/" target="_blank">IMBA</a>
          </v-layout>
        </v-layout>

        <v-layout>
          <v-flex col xs6>
            <img src="../assets/img/imp.png" height="70" class="ml-auto"/>
          </v-flex>
          <v-layout column justify-space-around col xs6>
            <a href="https://www.imp.ac.at/groups/johannes-zuber/" target="_blank">Zuber lab</a>
            <a href="https://www.imp.ac.at/" target="_blank">IMP</a>
          </v-layout>
        </v-layout>

        <v-layout>
          <v-flex col xs6>
            <img src="../assets/img/vbc.svg" height="70" class="ml-auto"/>
          </v-flex>
          <v-layout column justify-space-around col xs6>
            <a href="https://www.viennabiocenter.org/" target="_blank">VBC</a>
          </v-layout>
        </v-layout>

        <v-layout class="mt-1">
          <v-flex col xs6>
            <img src="../assets/img/kaminski.gif" height="70" class="ml-auto"/>
          </v-flex>
          <v-layout column justify-space-around col xs6>
            <a href="http://www.kaminskigrafik.ch/" target="_blank">Kaminskigrafik</a>
          </v-layout>
        </v-layout>
      </v-card>
    </v-flex>

    <v-dialog
        v-model="dialog"
        max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Other sgRNA tools</v-card-title>

        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title><a href="https://portals.broadinstitute.org/gpp/public/analysis-tools/sgrna-design/" target="_blank">GPP sgRNA Designer </a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title><a href="https://chopchop.cbu.uib.no/" target="_blank">chopchop</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title><a href="https://www.crisprscan.org/" target="_blank">CRISPRScan</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title><a href="https://crispr.cos.uni-heidelberg.de/" target="_blank">CRISPRater</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title><a href="http://www.deepcrispr.net/" target="_blank">deepCRISPR</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
              color="primary"
              text
              @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import Logo from '../components/Logo';

  export default {
    name: 'Link',
    components: {
      Logo
    },
    data() {
      return {
        dialog: false
      }
    }
  }
</script>

<style scoped>

</style>